module.exports = __webpack_public_path__ + "static/media/loading.db43a76d.svg";